// "Grid View" only kicks in above tablet size.
// A list-type horizontal card still shows for > 480 && < 768
export const selectIsGridLayout = (state) => {
	return state.layout.layout === 'grid' && !state.layout.isSmallScreen;
};

export const selectIsTabbedLayout = (state) => {
	return state.layout.isSmallScreen || selectIsGridLayout(state);
};
